function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cx from 'classnames';
var primary = 'inline-flex items-center px-4 py-2 border border-primary text-sm leading-5 font-medium rounded-md text-primary bg-white focus:outline-none focus:bg-primary-light transition ease-in-out duration-150';
var secondary = 'bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-1 px-4 rounded inline-flex items-center';
var secondaryDisabled = 'text-gray-500 opacity-50 cursor-not-allowed hover:bg-gray-300';

var Button = function Button(_ref) {
  var _ref2;

  var children = _ref.children,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "variant", "disabled"]);

  var isPrimary = variant === 'primary';
  var classes = isPrimary ? primary : secondary;
  var disabledClasses = !isPrimary && secondaryDisabled;
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props, {
    disabled: disabled,
    className: cx([classes, className, (_ref2 = {}, _ref2[disabledClasses] = !!disabled, _ref2)])
  }), children);
};

export default Button;